import { render, staticRenderFns } from "./EmbeddedVideo.vue?vue&type=template&id=fd4471a2&scoped=true"
import script from "./EmbeddedVideo.vue?vue&type=script&lang=ts"
export * from "./EmbeddedVideo.vue?vue&type=script&lang=ts"
import style0 from "./EmbeddedVideo.vue?vue&type=style&index=0&id=fd4471a2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4471a2",
  null
  
)

export default component.exports